const formatUserRole = (userRole) => {
  if (userRole == "owner") return "Profesional";
  if (userRole == "user") return "Asistente";
};

export { formatUserRole };
